import { call, put, takeLatest } from 'redux-saga/effects';
import {
	fetchWizardData,
	fetchWizardDataSuccess,
	fetchWizardDataFailure
} from '../actions/actions';

import { mainApi } from '../api/mainApi';

function* loadWizardData() {
	try {
		const plugins = yield call(mainApi('https://wpwizardapi.siteground.com/plugins'));
		const themes = yield call(mainApi('https://wpwizardapi.siteground.com/themes'));

		yield put(fetchWizardDataSuccess(plugins, themes));
	} catch (e) {
		console.error(`${e}`, e);
		yield put(fetchWizardDataFailure(e));
	}
}

function* data() {
	yield takeLatest(fetchWizardData, loadWizardData);
}

export default data;
